<form class="edit-profile" [formGroup]="form">
  <div class="img-content">
    <div class="profile-avatar">
      <span class="profile-name" *ngIf="!profileImg">
        {{ profileName }}
      </span>
      <img
        *ngIf="profileImg"
        class="img-circle"
        [src]="profileImg"
        alt="Profile"
      />
    </div>
    <div
      class="icon-change"
      (click)="!isUploading && changeProfileImg()"
      [class.disabled]="isUploading"
    >
      <div *ngIf="isUploading; else notLoadingTemplate" class="loading-spinner">
        <div class="spinner"></div>
      </div>
      <ng-template #notLoadingTemplate>
        <ng-container *ngIf="!profileImg; else deleteImageTemplate">
          <img src="assets/icons/camera.svg" alt="Edit image" />
        </ng-container>
        <ng-template #deleteImageTemplate>
          <img
            src="assets/icons/icon-cancel-white.svg"
            alt="Delete image"
            style="height: 16px; width: 16px"
          />
        </ng-template>
      </ng-template>
    </div>
  </div>
  <div class="form-container" *ngIf="this.pii && this.pii.attributes">
    <app-title-large>{{ "BasicInformation" | translate }}</app-title-large>

    <section class="form-group basic-infos">
      <div style="width: 100%">
        <app-shared-form-input-text
          [formControl]="formControls.first_name"
          id="first_name"
          name="first_name"
          label="{{ 'EditProfileFirstName' | translate }}"
          [showSuccessIcon]="isKycValidated"
        ></app-shared-form-input-text>
        <mat-error
          [style.visibility]="formErrors['first_name'] ? 'visible' : 'hidden'"
          class="error-message"
        >
          {{ "Name fields blank" | translate }}
        </mat-error>
      </div>
      <div style="width: 100%">
        <app-shared-form-input-text
          [formControl]="formControls.surname"
          id="surname"
          name="surname"
          label="{{ 'EditProfileSurname' | translate }}"
          [showSuccessIcon]="isKycValidated"
        ></app-shared-form-input-text>
        <mat-error
          [style.visibility]="formErrors['surname'] ? 'visible' : 'hidden'"
          class="error-message"
        >
          {{ "Name fields blank" | translate }}
        </mat-error>
      </div>
      <div style="width: 100%">
        <div class="form-field datepicker">
          <label for="birthdate">{{ "Dateofbirth" | translate }}</label>
          <div class="input-wrapper">
            <input
              [formControl]="formControls.date_of_birth"
              id="birthdate"
              name="date"
              [matDatepicker]="picker"
            />
            <div *ngIf="isKycValidated" class="success-icon">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <mat-datepicker-toggle matSuffix="" [for]="picker">
            <mat-icon matDatepickerToggleIcon="">calendar_month</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #picker=""></mat-datepicker>
        </div>
      </div>
      <div style="width: 100%">
        <div class="form-field phone">
          <label for="number">{{ "Phone" | translate }}</label>
          <ngx-mat-intl-tel-input
            id="phoneinput"
            [preferredCountries]="preferredCountries"
            [enablePlaceholder]="true"
            [enableSearch]="true"
            name="number"
            describedBy="phoneInput"
            [formControl]="formControls.phone"
            (ngModelChange)="changePhone($event)"
          ></ngx-mat-intl-tel-input>
          <mat-error
            [style.visibility]="formControls.phone.invalid && formControls.phone.touched ? 'visible' : 'hidden'"
            class="error-message"
            >{{ "Invalid phone number" | translate }}</mat-error
          >
        </div>
      </div>

      <div style="width: 100%; max-width: 100%">
        <app-shared-form-input-text
          [formControl]="formControls.email"
          id="email"
          name="email"
          label="{{ 'EditProfileEmail' | translate }}"
          [readonly]="true"
          [showSuccessIcon]="isKycValidated"
        ></app-shared-form-input-text>
      </div>

      <div style="width: 100%">
        <app-input-select
          [formControl]="formControls.language"
          id="language"
          name="language"
          label="{{ 'Language' | translate }}"
          (ngModelChange)="changeLang()"
          [options]="languageOptions"
        ></app-input-select>
      </div>
    </section>

    <section>
      <app-title-large>{{ "Address" | translate }}</app-title-large>
      <div class="form-group address">
        <app-profile-address-input
          style="width: 100%; max-width: 100%"
          [address]="pii.primary_address"
          (stateChange)="onAddressStateChange($event)"
          data-testid="client-edit-profile-address"
        ></app-profile-address-input>
      </div>
    </section>

    <div class="submit-actions">
      <button
        type="submit"
        class="act-btn save"
        (click)="handleSubmit()"
        [disabled]="!isFormValid || isSaving"
        [matTooltip]="(!isFormValid && !isSaving) ? getMissingFieldsTooltip() : ''"
        matTooltipPosition="above"
      >
        <ng-container *ngIf="isSaving; else toSaveTemplate">
          <mat-progress-spinner
            style="display: inline-block; top: 2px"
            mode="indeterminate"
            [diameter]="16"
          ></mat-progress-spinner>
          <span style="margin-left:8px">Carregando...</span>
        </ng-container>
        <ng-template #toSaveTemplate>
          {{ "Save" | translate }}
        </ng-template>
      </button>
    </div>
  </div>
</form>
